module.exports = {
    'users.index': 'users/',
    'users.update': 'users',
    'users.incomplete-registrations.store': 'incomplete-registrations',
    'users.incomplete-registrations.update': 'incomplete-registrations/$1',
    'users.postcheckout-questions.index': 'users/postcheckout-questions',
    'users.postcheckout-questions.store': 'users/postcheckout-questions',
    'users.register.store': 'users/register',
    'users.referral.index': 'user/referrals',
    'users.referral.store': 'user/referrals',
    'users.referral.update': 'user/referrals/$1',
    'users.referral.optout': 'user/referrals/optout/$1',
    'users.validate.email': 'validate/email',
    'users.validate.telephone': 'validate/telephone',
    'users.preferences.weekly-email.store': 'users/$1/preferences/weekly-email',
    'users.preferences.dislikes-lilies.store': 'users/$1/dislikes-lilies',
    'users.validate.registration.introductions.store': 'users/validate/registration/introductions',
    'users.validate.registration.delivery.store': 'users/validate/registration/delivery',
    'couponsHistory': 'user/coupons-history',
    'users.get-skip-delivery-reasons': '/skipping-delivery-reasons',
    'users.getSpecialDates': 'users/$1/occasions',
    'users.createSpecialDates': 'occasions',
    'users.updateSpecialDates': 'occasions/$1',
    'users.deleteSpecialDates': 'occasions/$1',
    'users.getOccasionTypes': 'occasions/types',
    'setupintents.users.store': 'setupintents/users',
    'users.terminal.connection': 'terminal-connection-token',
    'users.promotional-banners': 'promotional-banners',
    'users.outstanding-orders.index': 'users/$1/outstanding-orders',
    'users.outstanding-orders.update': 'users/$1/outstanding-orders',
    'users.themes': 'dashboard-themes',
    'users.update-feature.update': 'users/$1/update-feature',
};
